import { render, staticRenderFns } from "./pagamentoConfermato.vue?vue&type=template&id=3444709e"
import script from "./pagamentoConfermato.vue?vue&type=script&lang=js"
export * from "./pagamentoConfermato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports